import URL from '@/creditflowresearch/Router/urlConstants';

const ARTICLES_BASE_PATHS = [URL.MARKET_OVERVIEW_EM] as const;

export const getArticlesBasePath = (asPath: string): string =>
  ARTICLES_BASE_PATHS.find((base) => asPath.startsWith(base)) ?? '';
